<template>
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="calendar-search">
      <path
        id="Vector"
        d="M6.6665 4.79102C6.32484 4.79102 6.0415 4.50768 6.0415 4.16602V1.66602C6.0415 1.32435 6.32484 1.04102 6.6665 1.04102C7.00817 1.04102 7.2915 1.32435 7.2915 1.66602V4.16602C7.2915 4.50768 7.00817 4.79102 6.6665 4.79102Z"
        fill="#ffffff"
      />
      <path
        id="Vector_2"
        d="M13.3335 4.79102C12.9918 4.79102 12.7085 4.50768 12.7085 4.16602V1.66602C12.7085 1.32435 12.9918 1.04102 13.3335 1.04102C13.6752 1.04102 13.9585 1.32435 13.9585 1.66602V4.16602C13.9585 4.50768 13.6752 4.79102 13.3335 4.79102Z"
        fill="#ffffff"
      />
      <path
        id="Vector_3"
        d="M15.1667 18.4583C13.35 18.4583 11.875 16.9833 11.875 15.1667C11.875 13.35 13.35 11.875 15.1667 11.875C16.9833 11.875 18.4583 13.35 18.4583 15.1667C18.4583 16.9833 16.9833 18.4583 15.1667 18.4583ZM15.1667 13.125C14.0417 13.125 13.125 14.0417 13.125 15.1667C13.125 16.2917 14.0417 17.2083 15.1667 17.2083C16.2917 17.2083 17.2083 16.2917 17.2083 15.1667C17.2083 14.0417 16.2917 13.125 15.1667 13.125Z"
        fill="#ffffff"
      />
      <path
        id="Vector_4"
        d="M18.3332 18.9582C18.1749 18.9582 18.0165 18.8999 17.8915 18.7749L17.0582 17.9415C16.8165 17.6999 16.8165 17.2999 17.0582 17.0582C17.2999 16.8165 17.6999 16.8165 17.9415 17.0582L18.7749 17.8915C19.0165 18.1332 19.0165 18.5332 18.7749 18.7749C18.6499 18.8999 18.4915 18.9582 18.3332 18.9582Z"
        fill="#ffffff"
      />
      <path
        id="Vector_5"
        d="M7.08333 12.0837C6.975 12.0837 6.86666 12.0587 6.76666 12.0171C6.65833 11.9754 6.56666 11.917 6.49166 11.842C6.45833 11.8004 6.41667 11.7587 6.39167 11.717C6.35833 11.667 6.33333 11.6171 6.31667 11.5671C6.29167 11.5171 6.275 11.4671 6.26667 11.4171C6.25834 11.3587 6.25 11.3004 6.25 11.2504C6.25 11.0337 6.34166 10.8171 6.49166 10.6587C6.56666 10.5837 6.65833 10.5254 6.76666 10.4837C7.06666 10.3504 7.44167 10.4254 7.67501 10.6587C7.82501 10.8171 7.91667 11.0337 7.91667 11.2504C7.91667 11.3004 7.90833 11.3587 7.9 11.4171C7.89166 11.4671 7.875 11.5171 7.85 11.5671C7.83333 11.6171 7.80833 11.667 7.775 11.717C7.74167 11.7587 7.70834 11.8004 7.67501 11.842C7.51667 11.992 7.3 12.0837 7.08333 12.0837Z"
        fill="#ffffff"
      />
      <path
        id="Vector_6"
        d="M9.99984 12.084C9.78317 12.084 9.5665 11.9923 9.40816 11.8423C9.25816 11.684 9.1665 11.4756 9.1665 11.2506C9.1665 11.1423 9.19151 11.034 9.23317 10.934C9.27484 10.834 9.33316 10.7423 9.40816 10.659C9.7165 10.3507 10.2748 10.3507 10.5915 10.659C10.7415 10.8173 10.8332 11.034 10.8332 11.2506C10.8332 11.3006 10.8248 11.359 10.8165 11.4173C10.8082 11.4673 10.7915 11.5173 10.7665 11.5673C10.7498 11.6173 10.7248 11.6673 10.6915 11.7173C10.6582 11.759 10.6248 11.8006 10.5915 11.8423C10.4332 11.9923 10.2165 12.084 9.99984 12.084Z"
        fill="#ffffff"
      />
      <path
        id="Vector_7"
        d="M7.08333 15C6.86667 15 6.64999 14.9083 6.49166 14.7583C6.34166 14.6 6.25 14.3833 6.25 14.1667C6.25 14.0583 6.275 13.95 6.31667 13.85C6.35833 13.7417 6.41666 13.65 6.49166 13.575C6.79999 13.2667 7.36667 13.2667 7.67501 13.575C7.82501 13.7333 7.91667 13.95 7.91667 14.1667C7.91667 14.3833 7.82501 14.6 7.67501 14.7583C7.51667 14.9083 7.3 15 7.08333 15Z"
        fill="#ffffff"
      />
      <path
        id="Vector_8"
        d="M17.0832 8.19922H2.9165C2.57484 8.19922 2.2915 7.91589 2.2915 7.57422C2.2915 7.23255 2.57484 6.94922 2.9165 6.94922H17.0832C17.4248 6.94922 17.7082 7.23255 17.7082 7.57422C17.7082 7.91589 17.4248 8.19922 17.0832 8.19922Z"
        fill="#ffffff"
      />
      <path
        id="Vector_9"
        d="M11.1417 18.9577H6.66667C3.625 18.9577 1.875 17.2077 1.875 14.166V7.08268C1.875 4.04102 3.625 2.29102 6.66667 2.29102H13.3333C16.375 2.29102 18.125 4.04102 18.125 7.08268V10.8327C18.125 11.1743 17.8417 11.4577 17.5 11.4577C17.1583 11.4577 16.875 11.1743 16.875 10.8327V7.08268C16.875 4.69935 15.7167 3.54102 13.3333 3.54102H6.66667C4.28333 3.54102 3.125 4.69935 3.125 7.08268V14.166C3.125 16.5493 4.28333 17.7077 6.66667 17.7077H11.1417C11.4833 17.7077 11.7667 17.991 11.7667 18.3327C11.7667 18.6743 11.4833 18.9577 11.1417 18.9577Z"
        fill="#ffffff"
      />
    </g>
  </svg>
</template>
